import {useRef,useState} from "react";

export function GuideAudioPlayer({title,src,onClose}:{title:string;src:string;onClose:()=>void}){
  const [position,setPosition]=useState({x:Math.max(12,window.innerWidth-390),y:64});
  const drag=useRef<{pointerId:number;dx:number;dy:number}|null>(null);
  return <section className="guide-audio-player" role="dialog" aria-label={`Riproduzione audio: ${title}`} style={{left:position.x,top:position.y}}>
    <header
      onPointerDown={event=>{if((event.target as HTMLElement).closest("button"))return;drag.current={pointerId:event.pointerId,dx:event.clientX-position.x,dy:event.clientY-position.y};event.currentTarget.setPointerCapture(event.pointerId);}}
      onPointerMove={event=>{if(drag.current?.pointerId!==event.pointerId)return;setPosition({x:Math.max(0,Math.min(window.innerWidth-180,event.clientX-drag.current.dx)),y:Math.max(0,Math.min(window.innerHeight-60,event.clientY-drag.current.dy))});}}
      onPointerUp={event=>{if(drag.current?.pointerId===event.pointerId)drag.current=null;}}
      onPointerCancel={()=>{drag.current=null;}}
    >
      <strong title={title}>{title}</strong>
      <button type="button" aria-label="Chiudi lettore audio" onClick={onClose}>×</button>
    </header>
    <audio key={src} controls autoPlay preload="metadata" src={src}/>
  </section>;
}
